// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import router from './router'
import App from './App'
import http from './http/httpUtils'
import api from './http/api'
import loading from './components/loading'
import './components/Toast/index.css'
import Toast from './components/Toast/index'
// import { _debounce } from './utils/debounce'

Vue.prototype.$http = http // axios挂载
Vue.prototype.$api = api
// Vue.prototype.$debounce = _debounce()
Vue.use(loading)
Vue.use(Toast)
Vue.config.productionTip = false

Vue.directive('roll', {
  bind (el, binding) {
    let i = 0
    el.addEventListener('scroll', function () {
      let scroll = this.scrollTop - i
      i = this.scrollTop
      if (scroll < 0) {
        binding.value('up')
      } else {
        binding.value('down')
      }
    })
  }
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: {App},
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js